import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { AddPaymentAccountsRequestModel, AddPaymentAccountsResponseModel } from "@/features/accounts/payment/scraping/services/add-accounts-model";
import { Timeout } from "@/shared/services/http-client";

export class AddPaymentAccountsApi {
  /**
   * MoneyLook 口座追加API
   */
  public addPaymentAccounts = async (
    param: AddPaymentAccountsRequestModel
  ): Promise<AddPaymentAccountsResponseModel> => {
    const path = `/api/paymentaccounts/scraping/addaccounts`;
    const res = await ApiClient.instance.post<AddPaymentAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
      timeout: Timeout.VeryLong,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
